import {$isTableCellNode, $isTableSelection} from '@lexical/table';
import {
  $createRangeSelection,
  $getSelection,
  $setSelection,
  COMMAND_PRIORITY_CRITICAL,
  KEY_DOWN_COMMAND,
  LexicalEditor,
} from 'lexical';
import {useEffect} from 'react';

/**
 * Handles Cmd/Ctrl+V when table selection is active - focuses into first cell
 */
export function useTablePasteHandler(editor: LexicalEditor) {
  useEffect(() => {
    return editor.registerCommand(
      KEY_DOWN_COMMAND,
      (event: KeyboardEvent) => {
        // Check if this is a paste command (Cmd/Ctrl+V)
        if ((event.metaKey || event.ctrlKey) && event.key === 'v') {
          const selection = $getSelection();

          // If we have a table selection, focus into the first cell before paste
          if ($isTableSelection(selection)) {
            const nodes = selection.getNodes();
            const firstCell = nodes.find($isTableCellNode);

            if (firstCell) {
              // Get the first child of the cell (should be a paragraph or text node)
              const firstChild = firstCell.getFirstChild();

              if (firstChild) {
                // Create a range selection at the start of the first child
                const rangeSelection = $createRangeSelection();
                rangeSelection.anchor.set(firstChild.getKey(), 0, 'element');
                rangeSelection.focus.set(firstChild.getKey(), 0, 'element');
                $setSelection(rangeSelection);

                // Return false to allow the paste event to proceed with the new selection
                return false;
              }
            }
          }
        }

        return false;
      },
      COMMAND_PRIORITY_CRITICAL
    );
  }, [editor]);
}
